import { render, staticRenderFns } from "./header-hero.vue?vue&type=template&id=50e60e78&scoped=true&"
import script from "./header-hero.vue?vue&type=script&lang=js&"
export * from "./header-hero.vue?vue&type=script&lang=js&"
import style0 from "./header-hero.vue?vue&type=style&index=0&id=50e60e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e60e78",
  null
  
)

export default component.exports